<template>
  <v-dialog custom-class="select-content-dialog" title="Select SE/CE" :visible.sync="dialogVisible" :scrollbar="false"
    width="auto" @open="onOpen" @closed="onClosed">
    <div class="page-header">
      <div class="actions">
        <el-input size="small" prefix-icon="el-icon-search" placeholder="Search" v-model="searchVal"
          v-debounce="onSearch" clearable @clear="onSearch"></el-input>
      </div>
    </div>
    <div class="padding-lr">
      <el-table :data="pushList" ref="table" @selection-change="onSelectChange">
        <el-table-column type="selection" width="45" align="center" />
        <el-table-column prop="Name" label="SE/CE Name" sortable="custom" min-width="130" />
        <el-table-column prop="City" label="City" sortable="custom" min-width="130" />
        <el-table-column prop="Hospital" label="Hospital / Institution" sortable="custom" min-width="180" />
        <el-table-column prop="Department" label="Department" sortable="custom" min-width="130" />
        <el-table-column prop="MLName" label="MSL Name" sortable="custom" min-width="130" />
        <el-table-column prop="TeamName" label="Team" sortable="custom" min-width="160" />
      </el-table>
      <div class="pagination-wrap">
        <div class="actions">
          <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
            :current-page="currentPage" :page-sizes="[10, 25, 50, 100]" :page-size="pageSize"
            layout="total, sizes, prev, pager, next, jumper" :total="total" />
        </div>
      </div>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button type="primary" @click="onConfirm" :disabled="multipleSelection.length === 0">
        Select
      </el-button>
    </div>
  </v-dialog>
</template>
<script>
import { deepClone } from "../../utils";
export default {
  name: "select-se-dialog",
  props: {
    visible: {
      type: Boolean,
      default: false,
      required: true,
    },
    selected: Array,
  },
  data() {
    return {
      searchVal: "",
      currentPage: 1,
      pageSize: 10,
      total: 0,
      orderBy: "MLName",
      orderType: "descending",
      dialogVisible: this.visible,
      multipleSelection: [],
      data: [],
      pushList: [],
    };
  },
  watch: {
    visible(value) {
      this.dialogVisible = value;
    },
  },
  methods: {
    onSearch() {
      this.currentPage = 1;
      this.getSEList();
    },
    onSelectChange(selected) {
      this.multipleSelection = selected;
    },

    // onConfirm(){},
    onConfirm() {
      this.dialogVisible = false;
      const selected = this.filterSelected();
      this.$emit("select", selected);
    },
    onOpen() {
      if (this.data.length === 0) {
        this.getSEList();
      }
      if (this.selected) {
        this.multipleSelection = deepClone(this.selected);
        this.pushList = this.data.filter((i) => {
          return !this.selected.some((j) => j.SEID === i.SEID);
        });
      }
    },
    filterSelected() {
      return this.multipleSelection.filter((i) => {
        return !this.selected.some((j) => j.SEID === i.SEID);
      });
    },
    getSEList() {
      let params = {
        pageSize: this.pageSize,
        page: this.currentPage,
        orderBy: this.orderBy,
        orderType: this.orderType,
        key: this.searchVal,
      };
      this.axios
        .get(`/event/seList`, {
          params: params,
        })
        .then(({ code, data }) => {
          if (code === 200) {
            this.data = deepClone(data.data);
            this.data = data.data;
            this.pushList = deepClone(data.data);
            this.total = data.total;
          }
        });
    },
    handleSizeChange(pageSize) {
      this.pageSize = pageSize;
      this.getSEList();
    },
    handleCurrentChange(currentPage) {
      this.currentPage = currentPage;
      this.getSEList();
    },
    onClosed() {
      this.multipleSelection = [];
      this.$emit("update:visible", false);
      this.$emit("closed");
    },
  },
};
</script>
<style lang="scss" scoped>
.page-header {
  position: relative;
  padding-left: 15px;
  height: 40px;
  line-height: 40px;
  display: flex;
  flex-direction: row-reverse;
  align-items: center;

  .actions {
    display: flex;
    justify-content: center;
    align-items: center;

    .el-input+.el-button {
      margin-left: 20px;
    }
  }
}
</style>
